import { useOrganisationProgrammeQuery } from '@/composable/queries/Dara/programmes'
import { useAuthStore } from '@/stores/auth'

export function useProgrammeHelper() {
  const authStore = useAuthStore()

  const selectedOrganisationId = computed(() => {
    return authStore.selected_organisation_id ?? 0
  })

  const isProgrammeQueryEnabled = computed(() => {
    return Boolean(selectedOrganisationId.value) && selectedOrganisationId.value !== 0
  })

  const { isPending: isPendingProgrammes, data: organisationProgrammes } = useOrganisationProgrammeQuery(
    selectedOrganisationId,
    isProgrammeQueryEnabled,
  )

  const organisationProgrammesWithQuestionnaire = computed(() => organisationProgrammes.value?.filter(programme => programme.has_questionnaire))

  return {
    organisationProgrammes,
    organisationProgrammesWithQuestionnaire,
    isPendingProgrammes,
  }
}
